export const OCR_CONSTANTS = {
  MAX_FILE_SIZE_MB: 20,
  CAMERA_CONFIG: {
    facingMode: 'environment' as const,
    width: { min: 640, ideal: 1280, max: 1920 },
    height: { min: 480, ideal: 720, max: 1080 }
  },
  ACCEPTED_FORMATS: 'image/jpeg,image/jpg,image/png,image/gif,image/bmp',
  FILE_EXTENSIONS: ['JPG', 'PNG', 'GIF', 'BMP'] as const,
  CAMERA_FILENAME: 'camera-capture.jpg',
  MIME_TYPE_JPEG: 'image/jpeg'
} as const;

export const OCR_MESSAGES = {
  CAMERA_PERMISSION_ERROR: 'Could not access camera. Please make sure you have granted permission.',
  CAMERA_NOT_READY: 'Camera not ready. Please try again.',
  UPLOAD_ERROR: 'Error uploading image. Please try again.',
  INITIALIZING_CAMERA: 'Initializing camera...',
  ACCOUNT_LIMIT_REACHED: 'Account limit has been reached. Please try again later or upgrade your plan.'
} as const;
